import React, { useState } from 'react';
import { View, Text, Image, TouchableOpacity, Linking, SafeAreaView } from 'react-native';
import { useTranslation } from 'react-i18next';
import Config from 'react-native-config';
import { MainLayout } from './md-design-system/Layout';
import Button from './md-design-system/Button/Button';
import LoadingSpinner from './md-design-system/Layout/LoadingSpinner';

interface NoInternetScreenProps {
  onRetry?: () => Promise<void> | void;
}

export const NoInternetScreen: React.FC<NoInternetScreenProps> = ({ onRetry }) => {
  const { t } = useTranslation();
  const [isRetrying, setIsRetrying] = useState(false);
  const supportPhoneNumber = Config.SUPPORT_PHONE_NUMBER || '+390238592676';

  const handleContactSupport = () => {
    Linking.openURL(`tel:${supportPhoneNumber}`);
  };

  const handleRetry = async () => {
    if (isRetrying) return;
    setIsRetrying(true);
    try {
      await new Promise<void>(resolve => setTimeout(resolve, 1000));
      if (onRetry) {
        await onRetry();
      }
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <MainLayout isLoading={isRetrying}>
      <View className="flex-1 items-center justify-center px-6">
        <View className="mb-20">
          <Image
            source={require('@assets/images/medicilio_logo.png')}
            className="h-10 w-48"
            resizeMode="contain"
          />
        </View>

        <View className="mb-8">
          <Image
            source={require('@assets/images/no_connection.png')}
            className="w-64 h-64"
            resizeMode="contain"
          />
        </View>

        <Text className="text-center text-base mb-8 font-medium px-4 w-[80%]">
          {t('screens.noInternet.title')}
        </Text>

        <Button
          onPress={handleRetry}
          icon={isRetrying ? undefined : 'reload'}
          size='large'
          style={{ width: 300 }}
          disabled={isRetrying}
        >

          <Text className="text-white font-bold text-lg">{t('screens.noInternet.retry')}</Text>
        </Button>

        <View className="items-center mt-5">
          <Text className="text-primary-700 text-center text-base">
            {t('screens.noInternet.support')}
          </Text>
          <TouchableOpacity onPress={handleContactSupport}>
            <Text className="text-primary-700 font-bold text-center underline mt-1 text-base">
              {supportPhoneNumber}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </MainLayout>
  );
};
